/* eslint-disable max-len */
import React from 'react';
import moment from 'moment';
import Box from '@bit/knotchinc.web-react-components.box';
import { formatDate } from 'helpers/Utils.js';
import {
  ErrorTitle,
  ErrorText,
  ErrorDescriptionContainer,
  ErrorTitleGroupContainer,
  ErrorDateContainer,
} from './styled.js';

const ErrorNoPartnership = ({ error, request }) => {
  const { data = {} } = error;
  const { report_type, start_day, end_day } = request;
  const { avg_historical_partnerships } = data;
  return (
    <Box p="200px 0" width="100%" height="678px" m="0 auto">
      <ErrorDescriptionContainer width="600px">
        <ErrorTitleGroupContainer>
          <ErrorTitle uppercase dark>
            {error.title || `No ${report_type === 'brand' ? 'publisher' : 'brand'} partnerships to report during`}
            <ErrorDateContainer>{formatDate(moment(start_day), { short: true })}</ErrorDateContainer> -{' '}
            <ErrorDateContainer>{formatDate(moment(end_day), { short: true })}</ErrorDateContainer>
          </ErrorTitle>
          <ErrorText>
            {error.message ||
              `Looks like you and your competitors didn't partner with any ${
                report_type === 'brand' ? 'publisher' : 'brand'
              }s during this timeframe. This is notable in its own right! The average number of partnerships from your reports over the last six months has been `}
            <span>{avg_historical_partnerships}</span>.
          </ErrorText>
        </ErrorTitleGroupContainer>
      </ErrorDescriptionContainer>
    </Box>
  );
};

export default ErrorNoPartnership;
